import { useMemo } from 'react';
import { CustomerUser } from '@ansvar-sakerhet/api-client';

export const useCustomerUsersTableData = (customerUsers: CustomerUser[]) => {
  const columns = useMemo(() => {
    return [
      {
        Header: 'Namn',
        accessor: 'firstName',
      },
      {
        Header: 'Efternamn',
        accessor: 'lastName',
      },
      {
        Header: 'Externt id',
        accessor: 'externalId',
      },
      {
        Header: 'Dold',
        accessor: 'hidden',
      },
      {
        Header: 'Projekt',
        accessor: 'projectAccess',
      },
      {
        Header: '',
        accessor: 'events',
      },
      {
        Header: '',
        accessor: 'userId',
      },
    ] as const;
  }, []);

  const data = useMemo(() => {
    return customerUsers.map((user) => {
      return {
        firstName: user.firstName,
        lastName: user.lastName,
        externalId: user.externalId,
        hidden: user.hidden ? 'Ja' : 'Nej',
        projectAccess: user.hasAllProjectAccess ? 'Alla projekt' : 'Begränsad',
        userId: user.customerUserId,
        events: '',
      };
    });
  }, [customerUsers]);

  return { columns, data };
};
